import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const FormFooter = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    explanationMessage,
    validationMessage
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["className", "explanationMessage", "validationMessage"]);

  const theme = useTheme();
  return explanationMessage || validationMessage ? ___EmotionJSX("div", _extends({
    ref: ref,
    css: [{
      fontSize: theme.fontSize.small,
      lineHeight: theme.lineHeight.small,
      [theme.mq.medium]: {
        display: 'flex',
        width: '100%'
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:FormFooter;"],
    className: clsx('CK__FormFooter', className)
  }, rest), explanationMessage && ___EmotionJSX("div", {
    css: [{
      color: theme.fontColor.muted,
      marginTop: theme.space.xsmall,
      [theme.mq.medium]: {
        '&:not(:only-child)': {
          marginRight: theme.space.small
        }
      }
    }, theme.settings.contrast.enable && theme.settings.contrast.form && {
      '.u-contrast &': {
        color: theme.contrast.base
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:FormFooter;"]
  }, explanationMessage), validationMessage && ___EmotionJSX("div", {
    css: [{
      color: theme.color.danger.base,
      marginTop: theme.space.xsmall,
      [theme.mq.medium]: {
        marginLeft: 'auto'
      }
    }, theme.settings.contrast.enable && theme.settings.contrast.form && {
      '.u-contrast &': {
        color: theme.contrast.base
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:FormFooter;"]
  }, validationMessage)) : null;
});
export default FormFooter;